<template>
  <v-card class="rounded-card card-shadow fill-height">
    <v-card-title class="font-weight-bold pl-5">
      Listagem de vendas
    </v-card-title>
    <v-card-text class="text--primary">
      <div>
        <px-pendencias-lista-vendas
          :vendas="vendas" :loading="loading"
          :on-change-options="onChangeOptions"
          :options-list="optionsList"
          @update="onClickRefresh"/>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import paginationMixin from '@/mixins/pagination-mixin';
import IndicadoresMarketplace from '@/modules/indicadores-marketplace/indicadores-marketplace';
import PendenciasListaVendas from './PendenciasListaVendas.vue';

export default {
  props: {
    dataMes: Object,
  },
  mixins: [paginationMixin],
  data() {
    return {
      vendas: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'createdIn',
        sortDesc: true,
      },
      loading: false,
      optionsList: {},
      query: 'situacao in ("ENVIADA", "SOLICITADO_REVISAO")',
    };
  },
  methods: {
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getVendas();
    },
    onClickRefresh() {
      this.getVendas();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getVendas() {
      this.loading = true;
      const {
        limit,
        offset,
      } = this.listOptions;
      this.listOptions.filter = this.query;

      return IndicadoresMarketplace.getVendas({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.vendas = response.data;
          this.$emit('loaded', this.vendas);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  components: {
    pxPendenciasListaVendas: PendenciasListaVendas,
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
  },
};
</script>
